//@ts-nocheck
var PAYPAL_THEME = {
  "name": "paypal",
  "mode": "light",
  "sysSizeIconXs": "1.125rem",
  "sysSizeIconSm": "1.5rem",
  "sysSizeIconMd": "2rem",
  "sysSizeIconLg": "3rem",
  "sysSizeIconXl": "4rem",
  "sysSizePictogramSm": "6rem",
  "sysSizePictogramMd": "8.5rem",
  "sysSizePictogramLg": "10rem",
  "sysSizeCircleXs": "1.5rem",
  "sysSizeCircleSm": "2rem",
  "sysSizeCircleMd": "3rem",
  "sysSizeCircleLg": "4rem",
  "sysSizeCircleXl": "6rem",
  "sysSizeTapTargetTiny": "2rem",
  "sysSizeTapTargetXs": "2.5rem",
  "sysSizeTapTargetSm": "2.75rem",
  "sysSizeTapTargetDefault": "3rem",
  "sysSizeTapTargetLg": "4rem",
  "sysSizePointerWidthSm": "0.75rem",
  "sysSizePointerWidthLg": "1rem",
  "sysSizeIndicatorXs": "0.1875rem",
  "sysSizeIndicatorSm": "0.25rem",
  "sysSizeIndicatorMd": "0.375rem",
  "sysSizeIndicatorLg": "0.5rem",
  "sysSizeFieldSm": "3rem",
  "sysSizeFieldLg": "4rem",
  "sysSizeMediaXs": "22rem",
  "sysSizeMediaSm": "36rem",
  "sysSizeMediaMd": "47rem",
  "sysSizeMediaLg": "64rem",
  "sysSizeMediaXl": "72rem",
  "sysSizeMediaXxl": "90rem",
  "sysSpace0": "0rem",
  "sysSpace25": "0.125rem",
  "sysSpace50": "0.25rem",
  "sysSpace75": "0.375rem",
  "sysSpace100": "0.5rem",
  "sysSpace150": "0.75rem",
  "sysSpace200": "1rem",
  "sysSpace250": "1.25rem",
  "sysSpace300": "1.5rem",
  "sysSpace350": "1.75rem",
  "sysSpace400": "2rem",
  "sysSpace450": "2.25rem",
  "sysSpace500": "2.5rem",
  "sysSpace600": "3rem",
  "sysSpace700": "3.5rem",
  "sysSpace800": "4rem",
  "sysSpaceTiny": "0.125rem",
  "sysSpaceXs": "0.25rem",
  "sysSpaceSm": "0.5rem",
  "sysSpaceMd": "0.75rem",
  "sysSpaceLg": "1rem",
  "sysSpaceXl": "1.5rem",
  "sysSpaceJumbo": "2rem",
  "sysElevationLevel1Yoffset": "0.0625rem",
  "sysElevationLevel1Opacity": 0.08,
  "sysElevationLevel1Blur": "0.75rem",
  "sysElevationLevel2Yoffset": "0.125rem",
  "sysElevationLevel2Opacity": 0.1,
  "sysElevationLevel2Blur": "0.875rem",
  "sysElevationLevel3Yoffset": "0.125rem",
  "sysElevationLevel3Opacity": 0.1,
  "sysElevationLevel3Blur": "1.125rem",
  "sysElevationBlurCurve": 1,
  "sysElevationBlurSlope": -1,
  "sysElevationBlurBase": "0.625rem",
  "sysElevationOpacity": 0.15,
  "sysElevationBrightenFactor": 0.02,
  "sysElevationVerticalOffsetRatio": 1,
  "sysElevationHorizontalOffsetRatio": 0,
  "sysMotionTimingX1": 0,
  "sysMotionTimingY1": 0.9,
  "sysMotionTimingX2": 0.3,
  "sysMotionTimingY2": 1,
  "sysMotionDurationHover": "0.10s",
  "sysMotionDurationAction": "0.20s",
  "sysMotionDurationArrive": "0.50s",
  "sysMotionDurationDepart": "0.30s",
  "sysMotionDurationRepeat": "1.30s",
  "sysMotionDurationLinger": "7.00s",
  "sysMotionDurationEnterSmall": "0.20s",
  "sysMotionDurationEnterMedium": "0.30s",
  "sysMotionDurationEnterLarge": "0.50s",
  "sysMotionDurationExitSmall": "0.10s",
  "sysMotionDurationExitMedium": "0.20s",
  "sysMotionDurationExitLarge": "0.20s",
  "sysMotionDurationMoveSmall": "0.20s",
  "sysMotionDurationMoveMedium": "0.50s",
  "sysMotionDurationMoveLarge": "0.80s",
  "sysMotionDurationLoopBackForth": "0.50s",
  "sysMotionDurationLoopStandard": "1.30s",
  "sysMotionEasingEnterSmall": "0,0,0,1",
  "sysMotionEasingEnterMedium": "0.05,0.7,0.1,1",
  "sysMotionEasingEnterLarge": "0.05,0.7,0.1,1",
  "sysMotionEasingExitSmall": "0.3,0,1,1",
  "sysMotionEasingExitMedium": "0.3,0,0.8,0.15",
  "sysMotionEasingExitLarge": "0.3,0,0.8,0.15",
  "sysMotionEasingMoveSmall": "0.2,0,0,1",
  "sysMotionEasingMoveMedium": "0.2,0,0,1",
  "sysMotionEasingMoveLarge": "0.2,0,0,1",
  "sysMotionEasingLoopBackForth": "0.2,0,0,1",
  "sysMotionEasingLoopStandard": "0,0,1,1",
  "sysBorderThicknessNormal": "0.0625rem",
  "sysBorderThicknessEmphasis": "0.125rem",
  "sysBorderThicknessFocus": "0.1875rem",
  "sysBorderThicknessFocusOutline": "0.375rem",
  "sysBorderRadiusTiny": "0.125rem",
  "sysBorderRadiusXs": "0.125rem",
  "sysBorderRadiusSm": "0.25rem",
  "sysBorderRadiusMd": "0.5rem",
  "sysBorderRadiusLg": "0.75rem",
  "sysBorderRadiusXl": "1rem",
  "sysBorderRadiusJumbo": "2rem",
  "sysBorderRadiusInteractive": "50%",
  "sysTypographyDisplayStrongFamily": "PayPalOpen-Bold",
  "sysTypographyDisplayStrongSize": "4rem",
  "sysTypographyDisplayStrongWeight": 400,
  "sysTypographyDisplayStrongLineHeight": "4.5rem",
  "sysTypographyDisplayStrongLetterSpacing": "-1%",
  "sysTypographyDisplayStrongMaxScaleFactor": 1.25,
  "sysTypographyDisplayMediumFamily": "PayPalOpen-Bold",
  "sysTypographyDisplayMediumSize": "4rem",
  "sysTypographyDisplayMediumWeight": 400,
  "sysTypographyDisplayMediumLineHeight": "4.5rem",
  "sysTypographyDisplayMediumLetterSpacing": "-1%",
  "sysTypographyDisplayMediumMaxScaleFactor": 1.25,
  "sysTypographyDisplayFamily": "PayPalOpen-Regular",
  "sysTypographyDisplaySize": "4rem",
  "sysTypographyDisplayWeight": 400,
  "sysTypographyDisplayLineHeight": "4.5rem",
  "sysTypographyDisplayLetterSpacing": "-1%",
  "sysTypographyDisplayMaxScaleFactor": 1.25,
  "sysTypographyHeadingLgStrongFamily": "PayPalOpen-Bold",
  "sysTypographyHeadingLgStrongSize": "2rem",
  "sysTypographyHeadingLgStrongWeight": 400,
  "sysTypographyHeadingLgStrongLineHeight": "2.25rem",
  "sysTypographyHeadingLgStrongLetterSpacing": "0%",
  "sysTypographyHeadingLgStrongMaxScaleFactor": 1.5,
  "sysTypographyHeadingLgMediumFamily": "PayPalOpen-Bold",
  "sysTypographyHeadingLgMediumSize": "2rem",
  "sysTypographyHeadingLgMediumWeight": 400,
  "sysTypographyHeadingLgMediumLineHeight": "2.25rem",
  "sysTypographyHeadingLgMediumLetterSpacing": "0%",
  "sysTypographyHeadingLgMediumMaxScaleFactor": 1.5,
  "sysTypographyHeadingLgFamily": "PayPalOpen-Regular",
  "sysTypographyHeadingLgSize": "2rem",
  "sysTypographyHeadingLgWeight": 400,
  "sysTypographyHeadingLgLineHeight": "2.25rem",
  "sysTypographyHeadingLgLetterSpacing": "0%",
  "sysTypographyHeadingLgMaxScaleFactor": 1.5,
  "sysTypographyHeadingSmStrongFamily": "PayPalOpen-Bold",
  "sysTypographyHeadingSmStrongSize": "1.5rem",
  "sysTypographyHeadingSmStrongWeight": 400,
  "sysTypographyHeadingSmStrongLineHeight": "2rem",
  "sysTypographyHeadingSmStrongLetterSpacing": "0%",
  "sysTypographyHeadingSmStrongMaxScaleFactor": 1.5,
  "sysTypographyHeadingSmMediumFamily": "PayPalOpen-Bold",
  "sysTypographyHeadingSmMediumSize": "1.5rem",
  "sysTypographyHeadingSmMediumWeight": 400,
  "sysTypographyHeadingSmMediumLineHeight": "2rem",
  "sysTypographyHeadingSmMediumLetterSpacing": "0%",
  "sysTypographyHeadingSmMediumMaxScaleFactor": 1.5,
  "sysTypographyHeadingSmFamily": "PayPalOpen-Regular",
  "sysTypographyHeadingSmSize": "1.5rem",
  "sysTypographyHeadingSmWeight": 400,
  "sysTypographyHeadingSmLineHeight": "2rem",
  "sysTypographyHeadingSmLetterSpacing": "0%",
  "sysTypographyHeadingSmMaxScaleFactor": 1.5,
  "sysTypographyTitleStrongFamily": "PayPalOpen-Bold",
  "sysTypographyTitleStrongSize": "1.25rem",
  "sysTypographyTitleStrongWeight": 400,
  "sysTypographyTitleStrongLineHeight": "1.5rem",
  "sysTypographyTitleStrongLetterSpacing": "0%",
  "sysTypographyTitleStrongMaxScaleFactor": 2,
  "sysTypographyTitleMediumFamily": "PayPalOpen-Bold",
  "sysTypographyTitleMediumSize": "1.25rem",
  "sysTypographyTitleMediumWeight": 400,
  "sysTypographyTitleMediumLineHeight": "1.5rem",
  "sysTypographyTitleMediumLetterSpacing": "0%",
  "sysTypographyTitleMediumMaxScaleFactor": 2,
  "sysTypographyTitleFamily": "PayPalOpen-Regular",
  "sysTypographyTitleSize": "1.25rem",
  "sysTypographyTitleWeight": 400,
  "sysTypographyTitleLineHeight": "1.5rem",
  "sysTypographyTitleLetterSpacing": "0%",
  "sysTypographyTitleMaxScaleFactor": 2,
  "sysTypographyBodyStrongFamily": "PayPalOpen-Bold",
  "sysTypographyBodyStrongSize": "1rem",
  "sysTypographyBodyStrongWeight": 400,
  "sysTypographyBodyStrongLineHeight": "1.3125rem",
  "sysTypographyBodyStrongLetterSpacing": "0%",
  "sysTypographyBodyStrongMaxScaleFactor": 2,
  "sysTypographyBodyMediumFamily": "PayPalOpen-Bold",
  "sysTypographyBodyMediumSize": "1rem",
  "sysTypographyBodyMediumWeight": 400,
  "sysTypographyBodyMediumLineHeight": "1.3125rem",
  "sysTypographyBodyMediumLetterSpacing": "0%",
  "sysTypographyBodyMediumMaxScaleFactor": 2,
  "sysTypographyBodyFamily": "PayPalOpen-Regular",
  "sysTypographyBodySize": "1rem",
  "sysTypographyBodyWeight": 400,
  "sysTypographyBodyLineHeight": "1.3125rem",
  "sysTypographyBodyLetterSpacing": "0%",
  "sysTypographyBodyMaxScaleFactor": 2,
  "sysTypographyCaptionStrongFamily": "PayPalOpen-Bold",
  "sysTypographyCaptionStrongSize": "0.875rem",
  "sysTypographyCaptionStrongWeight": 400,
  "sysTypographyCaptionStrongLineHeight": "1.25rem",
  "sysTypographyCaptionStrongLetterSpacing": "0%",
  "sysTypographyCaptionStrongMaxScaleFactor": 2,
  "sysTypographyCaptionMediumFamily": "PayPalOpen-Bold",
  "sysTypographyCaptionMediumSize": "0.875rem",
  "sysTypographyCaptionMediumWeight": 400,
  "sysTypographyCaptionMediumLineHeight": "1.25rem",
  "sysTypographyCaptionMediumLetterSpacing": "0%",
  "sysTypographyCaptionMediumMaxScaleFactor": 2,
  "sysTypographyCaptionFamily": "PayPalOpen-Regular",
  "sysTypographyCaptionSize": "0.875rem",
  "sysTypographyCaptionWeight": 400,
  "sysTypographyCaptionLineHeight": "1.25rem",
  "sysTypographyCaptionLetterSpacing": "0%",
  "sysTypographyCaptionMaxScaleFactor": 2,
  "sysTypographyLinkLgFamily": "PayPalOpen-Bold",
  "sysTypographyLinkLgSize": "1rem",
  "sysTypographyLinkLgWeight": 400,
  "sysTypographyLinkLgLineHeight": "1.3125rem",
  "sysTypographyLinkLgLetterSpacing": "0%",
  "sysTypographyLinkLgUnderline": false,
  "sysTypographyLinkLgMaxScaleFactor": 2,
  "sysTypographyLinkSmFamily": "PayPalOpen-Bold",
  "sysTypographyLinkSmSize": "0.875rem",
  "sysTypographyLinkSmWeight": 400,
  "sysTypographyLinkSmLineHeight": "1.25rem",
  "sysTypographyLinkSmLetterSpacing": "0%",
  "sysTypographyLinkSmUnderline": false,
  "sysTypographyLinkSmMaxScaleFactor": 2,
  "sysTypographyTagStrongFamily": "PayPalOpen-Bold",
  "sysTypographyTagStrongSize": "0.75rem",
  "sysTypographyTagStrongWeight": 400,
  "sysTypographyTagStrongLineHeight": "1rem",
  "sysTypographyTagStrongLetterSpacing": "2%",
  "sysTypographyTagStrongMaxScaleFactor": 2,
  "sysTypographyTagMediumFamily": "PayPalOpen-Bold",
  "sysTypographyTagMediumSize": "0.75rem",
  "sysTypographyTagMediumWeight": 400,
  "sysTypographyTagMediumLineHeight": "1rem",
  "sysTypographyTagMediumLetterSpacing": "2%",
  "sysTypographyTagMediumMaxScaleFactor": 2,
  "sysTypographyTagFamily": "PayPalOpen-Regular",
  "sysTypographyTagSize": "0.75rem",
  "sysTypographyTagWeight": 400,
  "sysTypographyTagLineHeight": "1rem",
  "sysTypographyTagLetterSpacing": "2%",
  "sysTypographyTagMaxScaleFactor": 2,
  "sysTypographyDataVizStrongFamily": "PayPalOpen-Bold",
  "sysTypographyDataVizStrongSize": "0.625rem",
  "sysTypographyDataVizStrongWeight": 400,
  "sysTypographyDataVizStrongLineHeight": "0.75rem",
  "sysTypographyDataVizStrongLetterSpacing": "3%",
  "sysTypographyDataVizStrongMaxScaleFactor": 2,
  "sysTypographyDataVizMediumFamily": "PayPalOpen-Bold",
  "sysTypographyDataVizMediumSize": "0.625rem",
  "sysTypographyDataVizMediumWeight": 400,
  "sysTypographyDataVizMediumLineHeight": "0.75rem",
  "sysTypographyDataVizMediumLetterSpacing": "3%",
  "sysTypographyDataVizMediumMaxScaleFactor": 2,
  "sysTypographyDataVizFamily": "PayPalOpen-Regular",
  "sysTypographyDataVizSize": "0.625rem",
  "sysTypographyDataVizWeight": 400,
  "sysTypographyDataVizLineHeight": "0.75rem",
  "sysTypographyDataVizLetterSpacing": "3%",
  "sysTypographyDataVizMaxScaleFactor": 2,
  "sysTypographyButtonLgFamily": "PayPalOpen-Bold",
  "sysTypographyButtonLgSize": "1rem",
  "sysTypographyButtonLgWeight": 400,
  "sysTypographyButtonLgLineHeight": "1.3125rem",
  "sysTypographyButtonLgLetterSpacing": "0%",
  "sysTypographyButtonLgMaxScaleFactor": 2,
  "sysTypographyButtonSmFamily": "PayPalOpen-Bold",
  "sysTypographyButtonSmSize": "0.875rem",
  "sysTypographyButtonSmWeight": 400,
  "sysTypographyButtonSmLineHeight": "1.25rem",
  "sysTypographyButtonSmLetterSpacing": "0%",
  "sysTypographyButtonSmMaxScaleFactor": 2,
  "sysTypographyFieldLabelLgFamily": "PayPalOpen-Regular",
  "sysTypographyFieldLabelLgSize": "1rem",
  "sysTypographyFieldLabelLgWeight": 400,
  "sysTypographyFieldLabelLgLineHeight": "1.5rem",
  "sysTypographyFieldLabelLgLetterSpacing": "0%",
  "sysTypographyFieldLabelLgMaxScaleFactor": 2,
  "sysTypographyFieldLabelSmFamily": "PayPalOpen-Regular",
  "sysTypographyFieldLabelSmSize": "0.875rem",
  "sysTypographyFieldLabelSmWeight": 400,
  "sysTypographyFieldLabelSmLineHeight": "1.25rem",
  "sysTypographyFieldLabelSmLetterSpacing": "0%",
  "sysTypographyFieldLabelSmMaxScaleFactor": 2,
  "sysTypographyFieldValueXlFamily": "PayPalOpen-Regular",
  "sysTypographyFieldValueXlSize": "2.5rem",
  "sysTypographyFieldValueXlWeight": 400,
  "sysTypographyFieldValueXlLineHeight": "2.75rem",
  "sysTypographyFieldValueXlLetterSpacing": "0%",
  "sysTypographyFieldValueXlMaxScaleFactor": 1.5,
  "sysTypographyFieldValueLgFamily": "PayPalOpen-Regular",
  "sysTypographyFieldValueLgSize": "1.5rem",
  "sysTypographyFieldValueLgWeight": 400,
  "sysTypographyFieldValueLgLineHeight": "2rem",
  "sysTypographyFieldValueLgLetterSpacing": "0%",
  "sysTypographyFieldValueLgMaxScaleFactor": 2,
  "sysTypographyFieldValueSmFamily": "PayPalOpen-Regular",
  "sysTypographyFieldValueSmSize": "1rem",
  "sysTypographyFieldValueSmWeight": 400,
  "sysTypographyFieldValueSmLineHeight": "1.5rem",
  "sysTypographyFieldValueSmLetterSpacing": "0%",
  "sysTypographyFieldValueSmMaxScaleFactor": 2,
  "sysColorBackgroundMain": "#f1f2f3",
  "sysColorBackgroundAlt": "#dbdde0",
  "sysColorBackgroundSurface": "#ffffff",
  "sysColorBackgroundSurfaceHover": "#f1f2f3",
  "sysColorBackgroundSurfaceActive": "#dbdde0",
  "sysColorBackgroundHighContrast": "#001435",
  "sysColorBackgroundMediumContrast": "#545d68",
  "sysColorPrimaryMain": "#0544b5",
  "sysColorPrimaryMainHover": "#0070e0",
  "sysColorPrimaryMainActive": "#003087",
  "sysColorPrimaryContrast": "#ffffff",
  "sysColorPrimaryContrastHover": "#aecbff",
  "sysColorPrimaryContrastActive": "#73a5ff",
  "sysColorSecondaryMain": "#0070e0",
  "sysColorSecondaryMainHover": "#73a5ff",
  "sysColorSecondaryMainActive": "#003087",
  "sysColorSecondaryContrast": "#ffffff",
  "sysColorTertiaryMain": "#f1f2f3",
  "sysColorTertiaryMainHover": "#dbdde0",
  "sysColorTertiaryMainActive": "#b2b7bd",
  "sysColorTertiaryContrast": "#003087",
  "sysColorFeaturedMain": "#ffd140",
  "sysColorFeaturedMainHover": "#ffdf7b",
  "sysColorFeaturedMainActive": "#f1b700",
  "sysColorFeaturedContrast": "#003087",
  "sysColorUnselectedMain": "#dbdde0",
  "sysColorUnselectedMainHover": "#f1f2f3",
  "sysColorUnselectedMainActive": "#dbdde0",
  "sysColorUnselectedContrast": "#545d68",
  "sysColorSelectedMain": "#0070e0",
  "sysColorSelectedMainHover": "#73a5ff",
  "sysColorSelectedMainActive": "#003087",
  "sysColorSelectedContrast": "#ffffff",
  "sysColorSelectedRangeMain": "#aecbff",
  "sysColorSelectedRangeMainHover": "#73a5ff",
  "sysColorSelectedRangeMainActive": "#0070e0",
  "sysColorSelectedRangeContrast": "#003087",
  "sysColorLinkMain": "#0070e0",
  "sysColorLinkMainHover": "#73a5ff",
  "sysColorLinkMainActive": "#003087",
  "sysColorLinkAlt": "#001435",
  "sysColorLinkAltHover": "#9198a0",
  "sysColorLinkAltActive": "#545d68",
  "sysColorLinkContrast": "#ffffff",
  "sysColorLinkContrastHover": "#aecbff",
  "sysColorLinkContrastActive": "#73a5ff",
  "sysColorOverlayMain": "rgba(5, 5, 6, 0.55)",
  "sysColorOverlayMainHover": "rgba(5, 5, 6, 0.4)",
  "sysColorOverlayMainActive": "rgba(5, 5, 6, 0.7)",
  "sysColorOverlayContrast": "#ffffff",
  "sysColorAccent1Main": "#003087",
  "sysColorAccent1Contrast": "#ffffff",
  "sysColorAccent2Main": "#e02d50",
  "sysColorAccent2Contrast": "#ffffff",
  "sysColorAccent3Main": "#388c00",
  "sysColorAccent3Contrast": "#ffffff",
  "sysColorAccent4Main": "#7252cc",
  "sysColorAccent4Contrast": "#ffffff",
  "sysColorErrorMain": "#d50102",
  "sysColorErrorMainHover": "#fe7575",
  "sysColorErrorMainActive": "#870101",
  "sysColorErrorContrast": "#ffffff",
  "sysColorWarningMain": "#ffbe4a",
  "sysColorWarningMainHover": "#ffdf7b",
  "sysColorWarningMainActive": "#c07600",
  "sysColorWarningAlt": "#c07600",
  "sysColorWarningContrast": "#001435",
  "sysColorSuccessMain": "#0c6e11",
  "sysColorSuccessMainHover": "#8fd01d",
  "sysColorSuccessMainActive": "#0a570d",
  "sysColorSuccessContrast": "#ffffff",
  "sysColorSystemMain": "#001435",
  "sysColorSystemMainHover": "#9198a0",
  "sysColorSystemMainActive": "#545d68",
  "sysColorSystemContrast": "#ffffff",
  "sysColorInfoMain": "#dbdde0",
  "sysColorInfoMainHover": "#f1f2f3",
  "sysColorInfoMainActive": "#dbdde0",
  "sysColorInfoContrast": "#001435",
  "sysColorSpecialtyMain": "#7252cc",
  "sysColorSpecialtyMainHover": "#977fd9",
  "sysColorSpecialtyMainActive": "#5b38bf",
  "sysColorSpecialtyContrast": "#ffffff",
  "sysColorStructureBorderHighContrast": "#9198a0",
  "sysColorStructureBorderLowContrast": "#f1f2f3",
  "sysColorStructureDivider": "#dbdde0",
  "sysColorStructureFocus": "#097ff5",
  "sysColorStructureFocusOutline": "rgba(209, 229, 249, 0.9)",
  "sysColorStructureErrorOutline": "rgba(224, 45, 80, 0.16)",
  "sysColorStructureScrim": "rgba(5, 5, 6, 0.4)",
  "sysColorStructureShimmer": "#dbdde0",
  "sysColorStructureShimmerInverse": "#545d68",
  "sysColorStructureSheen": "rgba(255, 255, 255, 0.7)",
  "sysColorStructureShadow": "#000000"
}; // import {PAYPAL_THEME} from 'pp-tokens/build/web/theme/paypal/tokens'

export { PAYPAL_THEME };
